class StepsCarousel {
  constructor(section) {
    this.section = section;
    this.viewport = section.querySelector('[data-steps-viewport]');
    this.cards = Array.from(section.querySelectorAll('[data-steps-card]'));
    this.prevBtn = section.querySelector('[data-steps-prev]');
    this.nextBtn = section.querySelector('[data-steps-next]');
    this.dots = Array.from(section.querySelectorAll('[data-steps-dot]'));
    this.currentEl = section.querySelector('[data-steps-current]');

    this.total = this.cards.length;
    if (!this.viewport || this.total === 0) return;

    // Reprend l'index déjà actif côté serveur (utile après un re-render
    // partiel de l'éditeur), sinon démarre à 0.
    const preActive = this.cards.findIndex((card) => card.classList.contains('is-current'));
    this.currentIndex = preActive >= 0 ? preActive : 0;

    this.prevBtn?.addEventListener('click', () => this.goTo(this.currentIndex - 1));
    this.nextBtn?.addEventListener('click', () => this.goTo(this.currentIndex + 1));
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));

    this.bindSwipe();
    this.update();
  }

  goTo(index) {
    this.currentIndex = ((index % this.total) + this.total) % this.total;
    this.update();
  }

  update() {
    this.cards.forEach((card, i) => {
      card.classList.remove('is-current', 'is-prev', 'is-next');
      const diff = (i - this.currentIndex + this.total) % this.total;
      if (diff === 0) {
        card.classList.add('is-current');
      } else if (diff === 1) {
        card.classList.add('is-next');
      } else if (diff === this.total - 1) {
        card.classList.add('is-prev');
      }
    });

    this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.currentIndex));

    if (this.currentEl) this.currentEl.textContent = this.currentIndex + 1;
  }

  bindSwipe() {
    let startX = 0;
    let tracking = false;

    this.viewport.addEventListener(
      'touchstart',
      (e) => {
        startX = e.touches[0].clientX;
        tracking = true;
      },
      { passive: true }
    );

    this.viewport.addEventListener(
      'touchend',
      (e) => {
        if (!tracking) return;
        tracking = false;
        const deltaX = e.changedTouches[0].clientX - startX;
        const threshold = 40;
        if (deltaX > threshold) {
          this.goTo(this.currentIndex - 1);
        } else if (deltaX < -threshold) {
          this.goTo(this.currentIndex + 1);
        }
      },
      { passive: true }
    );
  }
}

// Toujours (ré)initialiser : premier chargement de la page, ou re-render de
// section déclenché par l'éditeur de thème (ajout / suppression /
// réorganisation de bloc).
function initStepsCarousels(root = document) {
  const sections = root.matches?.('.steps-carousel')
    ? [root]
    : Array.from(root.querySelectorAll('.steps-carousel'));

  sections.forEach((section) => new StepsCarousel(section));
}

document.addEventListener('DOMContentLoaded', () => initStepsCarousels());

// Éditeur de thème Shopify
document.addEventListener('shopify:section:load', (event) => initStepsCarousels(event.target));
document.addEventListener('shopify:block:select', (event) => initStepsCarousels(event.target));